(function () {
  if (customElements.get("accordion-component")) {
    return;
  }

  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const clickedTitle = event.target.closest(".accordion-component__item-title");
        if (!clickedTitle) return;

        const clickedItem = clickedTitle.parentElement;
        
        // Toggle active class on clicked item
        clickedItem.classList.toggle("is-active");

        // Remove active class from siblings
        const siblings = Array.from(this.querySelectorAll(".accordion-component__item"));
        siblings.forEach(item => {
          if (item !== clickedItem) {
            item.classList.remove("is-active");
          }
        });
      });
    }
  }

  customElements.define("accordion-component", AccordionComponent);

  // --- Hash-driven open + scroll (e.g. RTE links like <a href="#how-to-use">) ---

  // Mobile only — matches Dawn's 750px breakpoint (see scroll-navigation.js).
  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function getHeaderHeight() {
    const header = document.querySelector(".header-wrapper");
    return header ? header.offsetHeight : 0;
  }

  // Resolve the <accordion-component> targeted by a slug, or null.
  function accordionForSlug(slug) {
    if (!slug) return null;
    const el = document.getElementById(slug);
    if (!el) return null;
    return el.matches("accordion-component") ? el : null;
  }

  function activateAccordion(wrapper) {
    if (!wrapper) return;

    const item = wrapper.querySelector(".accordion-component__item");
    if (item) item.classList.add("is-active");

    const top =
      wrapper.getBoundingClientRect().top + window.scrollY - getHeaderHeight();
    window.scrollTo({ top, behavior: "smooth" });
  }

  function activateFromHash() {
    if (!isMobile()) return;
    const slug = (window.location.hash || "").replace(/^#/, "");
    activateAccordion(accordionForSlug(slug));
  }

  // Deep links from other pages (/products/x#how-to-use).
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", activateFromHash);
  } else {
    activateFromHash();
  }

  // In-page navigation that changes the hash.
  window.addEventListener("hashchange", activateFromHash);

  // Intercept in-page anchor clicks so we open + offset-scroll even when the
  // hash is unchanged (hashchange won't fire on a re-click of the same link).
  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const slug = (link.getAttribute("href") || "").replace(/^#/, "");
    const wrapper = accordionForSlug(slug);
    if (!wrapper) return;

    // Custom tags open + scroll on every viewport; all other links are mobile-only.
    // Desktop RTE links keep native behavior (no preventDefault) — bail before it.
    const allowScroll = link.closest(".custom-tags") || isMobile();
    if (!allowScroll) return;

    // Stop the browser's native #-jump so we control the offset scroll.
    event.preventDefault();

    if (window.location.hash !== "#" + slug) {
      history.pushState(null, "", "#" + slug);
    }
    activateAccordion(wrapper);
  });
})();
